<div *ngIf="facade.languageSelectorContent$ | async as languageSelectorContent">
  <idp-language-selector
    (openFlyoutModal)="facade.open()"
    (changeLangEvent)="facade.changeLanguage()"
    (analyticsClick)="onAnalyticsClick($event)"
    [content]="languageSelectorContent"
  ></idp-language-selector>
</div>
